// src/utils/constants.js

export const userTypeOptions = [
  { role: 'guest', label: 'Guest' },
  { role: 'manager', label: 'Manager' },
  { role: 'assistant_manager', label: 'Assistant Manager' },
  { role: 'overseer', label: 'Overseer' },
];
